!((document, Drupal, drupalSettings, $) => {
  'use strict';

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.secondaryMenu = {
    attach: function (context, settings) {
      let search = $('.secondary-menu__search', context);
      let searchFieldToggler = search.find('.toggle-search-field', context);
      let searchFieldBlock = search.find('#block-exposedformsearchpage-2', context);
      let searchFieldBlockInput = searchFieldBlock.find('input[type=text]');
      searchFieldToggler.on('click', function () {
        searchFieldBlockInput.focus();
        searchFieldBlock.addClass('active');
      });
      searchFieldBlockInput.on('blur', function() {
        searchFieldBlock.removeClass('active');
      });
    }
  };
})(document, Drupal, drupalSettings, jQuery);
